//@ts-check
import React from 'react';
import FilterExpressionFormGroup from './FilterExpressionGroup';
import FilterExpressionFormInput from './FilterExpression';
import FilterTypeFormInput from './FilterType';
import FilterAddExpression from './FilterAddExpression';
/**
 * @param {import('./types').FilterItemProps } props
 */

var FilterItem = function FilterItem(props) {
  var item = props.item,
      isLast = props.isLast,
      onAdd = props.onAdd,
      onChange = props.onChange,
      onDelete = props.onDelete,
      onCombineChange = props.onCombineChange;
  var expIdx = item.index;

  if (item.type === 'group') {
    var group = item.item;
    var lastIdx = expIdx + group.Expressions.length - 1;
    var lastExp = group.Expressions[group.Expressions.length - 1];
    return React.createElement(FilterExpressionFormGroup, {
      group: group
    }, group.Expressions.map(function (exp, idx) {
      var isLast = idx === group.Expressions.length - 1;
      var gExpIdx = expIdx + idx;
      return React.createElement("div", {
        key: gExpIdx
      }, React.createElement(FilterExpressionFormInput, {
        value: exp,
        expIdx: gExpIdx,
        onChange: onChange,
        onDelete: onDelete
      }), !isLast && React.createElement(FilterTypeFormInput, {
        expIdx: gExpIdx,
        value: exp.Combine,
        onChange: onCombineChange
      }));
    }), React.createElement(FilterAddExpression, {
      onClick: function onClick(newGroup) {
        return onAdd(lastIdx, group.Group, newGroup);
      },
      group: false
    }), React.createElement(FilterTypeFormInput, {
      isLast: true,
      expIdx: lastIdx,
      value: lastExp.Combine || 'AND',
      onChange: onCombineChange
    }));
  }

  var exp = item.item;
  return React.createElement(React.Fragment, null, React.createElement(FilterExpressionFormInput, {
    key: expIdx,
    expIdx: expIdx,
    value: exp,
    onChange: onChange,
    onDelete: onDelete
  }), !isLast && React.createElement(FilterTypeFormInput, {
    expIdx: expIdx,
    value: exp.Combine,
    onChange: onCombineChange
  }));
};

FilterItem.defaultProps = {};
export default React.memo(FilterItem);